import type {
  BackendType,
  ContextHeaderType,
  LocaleType,
  RegionType,
  StoreType,
} from "./types"

function getStoreId(
  backend: BackendType = "hcl",
  locale: LocaleType = "en-GB"
): StoreType {
  if (backend === "hcl") {
    return locale === "en-GB" ? "10151" : "10152"
  }
  return locale === "en-GB" ? "uk" : "us"
}

export function toRegionType(locale: LocaleType): RegionType {
  switch (locale) {
    case "en-US":
      return "us"
    case "en-GB":
    default:
      return "uk"
  }
}

export function toContextHeader(
  region: RegionType,
  backend: BackendType = "hcl"
): ContextHeaderType {
  const locale = region === "us" ? "en-US" : "en-GB"
  const storeid = getStoreId(backend, locale)

  return {
    locale,
    backend,
    storeid,
  }
}
